import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').service('dashboardService', dashboardService);

    function dashboardService(DATES, utilService) {
        var ENUMS = {
            DATES: DATES,
            CAPACITY_FORMATS: {
                KILO: 'kWh/h',
                MEGA: 'MWh/h',
                K_WH_H: 'kWh/h',
                M_WH_H: 'MWh/h'
            },
            CAPACITY_PRICE_FORMATS: {
                UNIT: false,
                SUBUNIT: true
            },
            WIDGETS: {
                NOTIFICATIONS: 'NOTIFICATIONS',
                AUCTIONS: 'AUCTIONS',
                NETWORK_POINTS: 'NETWORK_POINTS',
                ACTIVITIES: 'ACTIVITIES',
                PROPOSALS: 'PROPOSALS'
            }
        };

        var loggedIn = {
            user: null,
            shipper: null
        };

        var settings = {
            widgets: [],
            favoriteNetworkPoints: [],
            capacityFormat: null,
            capacityPriceWithSubUnit: null,
            recentActivities: null,
            recentActivitiesForCompany: null
        };

        function saveShipperUser(user) {
            loggedIn.user = user;
        }

        function saveShipper(shipper) {
            loggedIn.shipper = shipper;
        }

        function savePlatformSettings(setting) {
            settings.capacityFormat = mapCapacityFormat(setting.amount);
            settings.capacityPriceWithSubUnit = mapCapacityPrice(setting.cost);
            settings.recentActivities = setting.recentActivities;
            settings.recentActivitiesForCompany =
                setting.recentActivities === 'SHIPPER';
        }

        function saveDashboardSettings(setting) {
            saveWidgetSettings(setting.activeWidgetList);
        }

        function mapCapacityFormat(format) {
            var keys = Object.keys(ENUMS.CAPACITY_FORMATS);
            for (var i = 0; i < keys.length; i++) {
                if (keys[i] == format) {
                    return utilService.values(ENUMS.CAPACITY_FORMATS)[i];
                }
            }
            return null;
        }

        function mapCapacityPrice(priceUnit) {
            var keys = Object.keys(ENUMS.CAPACITY_PRICE_FORMATS);
            for (var i = 0; i < keys.length; i++) {
                if (keys[i] == priceUnit) {
                    return utilService.values(ENUMS.CAPACITY_PRICE_FORMATS)[i];
                }
            }
            return null;
        }

        function saveWidgetSettings(activeWidgetList) {
            settings.widgets.splice(0, settings.widgets.length);

            var PREFIX = 'app/dashboard/';
            for (var i = 0; i < activeWidgetList.length; i++) {
                var key = activeWidgetList[i];
                var page = '';
                switch (key) {
                    case ENUMS.WIDGETS.NOTIFICATIONS: {
                        page = 'notifications.html';
                        break;
                    }
                    case ENUMS.WIDGETS.AUCTIONS: {
                        page = 'current-auctions.html';
                        break;
                    }
                    case ENUMS.WIDGETS.NETWORK_POINTS: {
                        page = 'favorite-network-points.html';
                        break;
                    }
                    case ENUMS.WIDGETS.ACTIVITIES: {
                        page = 'activities.html';
                        break;
                    }
                    case ENUMS.WIDGETS.PROPOSALS: {
                        page = 'trade-proposals.html';
                        break;
                    }
                }
                settings.widgets.push({ key: key, page: PREFIX + page });
            }
        }

        return {
            ENUMS: ENUMS,
            loggedIn: loggedIn,
            settings: settings,
            saveShipperUser: saveShipperUser,
            saveShipper: saveShipper,
            savePlatformSettings: savePlatformSettings,
            saveDashboardSettings: saveDashboardSettings
        };
    }
})();
